import { CSSProperties } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import AssistantChat from 'components/Assistant/MaestroChat'
import { styx } from 'modules/Utils';
import useScreen from 'Hooks/useScreen';
import ButtonSymphony from 'elements/ButtonSymphony';
import TagSymphony from 'elements/TagSymphony';

interface NotFoundPageProps {
    isPublic?: boolean;
}

const NotFoundPage = ({ isPublic = false }: NotFoundPageProps) => {
    const history = useHistory()
    const { isAuthenticated, loginWithRedirect } = useAuth0()
    const { mobileView, mStyle } = useScreen()

    const handleGoHome = () => {
        history.push('/')
    }

    const handleGetStarted = () => {
        if (isAuthenticated) {
            history.push('/')
        } else {
            loginWithRedirect()
        }
    }

    return (
        <div className="notFoundPageWrapper" style={mStyle(sty, 'notFoundPageWrapper')}>
            <div className="notFoundPageBackground" style={sty.notFoundPageBackground}>

                <div className="notFoundContent" style={mStyle(sty, 'notFoundContent')}>
                    <div className="notFoundContainer" style={mStyle(sty, 'notFoundContainer')}>
                        <TagSymphony
                            className="notFoundTag"
                            color="purple"
                            style={sty.notFoundTag}
                        >
                            404 Error
                        </TagSymphony>

                        <h1 className="notFoundTitle" style={mStyle(sty, 'notFoundTitle')}>
                            <span style={sty.titleGradient}>Page not found</span>
                        </h1>

                        <p className="notFoundSubtitle" style={mStyle(sty, 'notFoundSubtitle')}>
                            The page you're looking for doesn't exist or has been moved.
                        </p>

                        <div className="notFoundActions" style={mStyle(sty, 'notFoundActions')}>
                            <ButtonSymphony
                                className="goHomeButton"
                                variant="primary"
                                color="purple"
                                size="large"
                                onClick={handleGoHome}
                            >
                                Go to Homepage
                            </ButtonSymphony>

                            {!isAuthenticated && (
                                <ButtonSymphony
                                    className="getStartedButton"
                                    variant="outlined"
                                    color="purple"
                                    size="large"
                                    onClick={handleGetStarted}
                                    style={sty.getStartedButton}
                                >
                                    Get Started
                                </ButtonSymphony>
                            )}
                        </div>

                        <div className="maestroSuggestion" style={mStyle(sty, 'maestroSuggestion')}>
                            <AssistantChat
                                title="Anything I can help with?"
                                customChatComponentStyling={
                                    {
                                        padding: 0
                                    }
                                } />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    notFoundPageWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        backgroundColor: '#181818',
        backgroundImage: 'url(https://cdn.prod.website-files.com/61fc721130a4089acadae508/6685b3d152d239f14cf16fb7_bg.svg)',
        backgroundPosition: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
    },
    notFoundPageWrapper_mobile: {
        minHeight: '100vh',
    },
    notFoundPageBackground: {
        transition: 'background-image 0.3s ease',
        backgroundImage: 'url(https://cdn.prod.website-files.com/61fc721130a4089acadae508/66fe31f8761af995712da428_overlay-header.svg)',
        backgroundPosition: '100% 0',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    notFoundContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        paddingTop: 80,
        paddingBottom: 80,
        paddingLeft: 20,
        paddingRight: 20,
    },
    notFoundContent_mobile: {
        paddingTop: 40,
        paddingBottom: 40,
        paddingLeft: 16,
        paddingRight: 16,
    },
    notFoundContainer: {
        maxWidth: 600,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
    },
    notFoundTag: {
        marginBottom: 24,
    },
    notFoundTitle: {
        fontFamily: 'Din", serif',
        fontOpticalSizing: 'auto',
        fontSize: 64,
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: 1.1,
        margin: 0,
    },
    notFoundTitle_mobile: {
        fontSize: 40,
    },
    titleGradient: {
        background: 'linear-gradient(90deg, #d48afe 20%, #a9acfa 45%, #80ccf6 73%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        display: 'inline-block',
    },
    notFoundSubtitle: {
        fontSize: 20,
        color: 'rgba(255, 255, 255, 0.75)',
        fontWeight: 400,
        lineHeight: '140%',
        margin: 0,
    },
    notFoundSubtitle_mobile: {
        fontSize: 18,
    },
    notFoundActions: {
        display: 'flex',
        gap: 16,
        justifyContent: 'center',
        marginBottom: 40,
        alignItems: 'center',
    },
    notFoundActions_mobile: {
        flexDirection: 'column',
        gap: 12,
        marginBottom: 32,
    },
    getStartedButton: {
        borderColor: 'rgba(255, 255, 255, 0.3)',
        color: 'rgba(255, 255, 255, 0.9)',
    },
    maestroSuggestion: {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 16,
        padding: 24,
        border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    maestroSuggestion_mobile: {
        padding: 20,
        borderRadius: 12,
    },
    maestroSuggestionText: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '140%',
        margin: 0,
    },
    maestroSuggestionText_mobile: {
        fontSize: 14,
    },
}

export default NotFoundPage 